import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import { useCurrentOrganization } from '@/modules/core/hooks';

const QUERY_KEY = 'GET_PLAN_CIP_CONFIG';

const useGetPlanCIPConfigQuery = () => {
  const {
    observingOrganization: { id, type },
  } = useCurrentOrganization();
  const { data, isLoading, isSuccess } = useQuery(
    [QUERY_KEY, id, type],
    () => api.get(API_URL.METRICS_CIP_CONFIG),
    {
      retry: 0,
    }
  );
  const formattedData = useMemo(() => {
    const currentData = data?.data;
    return {
      isShowed: currentData?.show_cip_metrics || false,
      CIPAccountDelayDays: currentData?.cip_account_closure_delay_days,
    };
  }, [data?.data]);
  return {
    data: formattedData,
    isLoading,
    isSuccess,
  };
};
export default useGetPlanCIPConfigQuery;
